import { render, staticRenderFns } from "./DialogUploadPdfDienNuoc.vue?vue&type=template&id=03583ba4"
import script from "./DialogUploadPdfDienNuoc.vue?vue&type=script&lang=js"
export * from "./DialogUploadPdfDienNuoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports